"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = require("react");
var stockApiPing_1 = require("../../graphql/queries/stockApiPing");
var useErrorHandler_1 = require("../useErrorHandler");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var useCheckoutContext_1 = require("../useCheckoutContext");
var useStockApiPing = function () {
    var _a;
    var hourDisableOrderNowFromTo = usePlatformConfig_1.default().platformConfig.platformFeatures.hourDisableOrderNowFromTo;
    var isStock = useCheckoutContext_1.default().isStock;
    var _b = react_1.useState(false), isTimeDisabled = _b[0], setIsTimeDisabled = _b[1];
    var _c = react_1.useState(false), isPingAvailable = _c[0], setIsPingAvailable = _c[1];
    if (((_a = hourDisableOrderNowFromTo) === null || _a === void 0 ? void 0 : _a.length) && isStock) {
        var _d = client_1.useQuery(stockApiPing_1.default.GET_STOCKAPIPING, {
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }), data_1 = _d.data, error = _d.error;
        useErrorHandler_1.default(error);
        react_1.useEffect(function () {
            var _a;
            setIsPingAvailable((_a = data_1) === null || _a === void 0 ? void 0 : _a.stockApiPing);
            var currentHours = new Date().getHours();
            var startHour = hourDisableOrderNowFromTo[0], endHour = hourDisableOrderNowFromTo[1];
            var isRangeInvalid = endHour - startHour < 0;
            var isAfterOrAtStart = currentHours >= startHour;
            var isBeforeEnd = currentHours < endHour;
            var timeDisabled = isRangeInvalid ? isAfterOrAtStart || isBeforeEnd : isAfterOrAtStart && isBeforeEnd;
            setIsTimeDisabled(timeDisabled);
        }, [data_1]);
    }
    var isOrderPlacementDisabled = hourDisableOrderNowFromTo && (isTimeDisabled || !isPingAvailable);
    return { isOrderPlacementDisabled: isOrderPlacementDisabled };
};
exports.default = useStockApiPing;
